import { jsxs as _jsxs } from "react/jsx-runtime";
import { z } from 'zod';
export const QuotePropsSchema = z
    .object({
    body: z.string(),
    cite: z.string().optional(),
})
    .strict();
/** Renders a `quote` block. */
export function QuotePrimitive({ body, cite }) {
    return (_jsxs("blockquote", { className: "border-l-2 border-accent pl-4", children: [_jsxs("p", { className: "font-display text-base italic leading-relaxed text-foreground/90", children: ["\u201C", body, "\u201D"] }), cite ? _jsxs("cite", { className: "mt-1 block text-xs text-muted-foreground", children: ["\u2014 ", cite] }) : null] }));
}
